/**
 * ZodiacWheel — onboarding illustration (220×220 inline SVG).
 * Verbatim port of mobile.html onboarding screen SVG.
 */
import type { ReactElement } from "react";

export function ZodiacWheel({ size = 220 }: { readonly size?: number }): ReactElement {
  return (
    <svg width={size} height={size} viewBox="0 0 220 220" aria-hidden="true">
      <defs>
        <radialGradient id="zw-g1">
          <stop offset="0" stopColor="#5BC4D8" stopOpacity="0.3" />
          <stop offset="1" stopColor="#5BC4D8" stopOpacity="0" />
        </radialGradient>
      </defs>
      <circle cx="110" cy="110" r="100" fill="url(#zw-g1)" />
      <circle
        cx="110"
        cy="110"
        r="95"
        fill="none"
        stroke="#D4A843"
        strokeWidth="0.6"
        opacity="0.6"
      />
      <circle cx="110" cy="110" r="78" fill="none" stroke="#3A4A7A" strokeWidth="0.5" />
      <circle cx="110" cy="110" r="58" fill="none" stroke="#3A4A7A" strokeWidth="0.5" />
      <g stroke="#3A4A7A" strokeWidth="0.4" opacity="0.7">
        <line x1="110" y1="15" x2="110" y2="205" />
        <line x1="15" y1="110" x2="205" y2="110" />
        <line x1="42" y1="42" x2="178" y2="178" />
        <line x1="178" y1="42" x2="42" y2="178" />
      </g>
      <g fontFamily="serif" fontSize="11" fill="#C9B57E" textAnchor="middle">
        <text x="200" y="113">
          ♈
        </text>
        <text x="155" y="195">
          ♋
        </text>
        <text x="20" y="113">
          ♎
        </text>
        <text x="65" y="25">
          ♑
        </text>
      </g>
      <g fontFamily="serif" fontSize="14" fill="#E8C158" textAnchor="middle">
        <text x="135" y="85">
          ☉
        </text>
        <text x="80" y="135">
          ☽
        </text>
        <text x="155" y="140">
          ♃
        </text>
      </g>
      <line x1="135" y1="85" x2="80" y2="135" stroke="#5BC4D8" strokeWidth="0.7" opacity="0.7" />
      <line x1="80" y1="135" x2="155" y2="140" stroke="#D85B5B" strokeWidth="0.7" opacity="0.6" />
      <circle cx="110" cy="110" r="2" fill="#D4A843" />
    </svg>
  );
}
